<template>
  <div class="sms-temp">
    <h3>SMS 발송(수동)</h3>

    <!-- 검색조건 -->
    <div class="toolbar">
      <div class="tb-left">
        <input v-model="filters.centerName" class="ed ed-sm" placeholder="센터명" />
        <button class="btn" @click="centerPopup=true">검색</button>
        <input v-model="filters.name" class="ed ed-sm" placeholder="이름" />
        <button class="btn" @click="memberPopup=true">검색</button>
        <input v-model="filters.phone" class="ed ed-sm" placeholder="전화번호" />
        <select v-model="filters.msgType" class="ed">
          <option value="">메시지 종류(전체)</option>
          <option value="L">LMS</option>
          <option value="S">SMS</option>
        </select>
        <select v-model="filters.sendResult" class="ed">
          <option value="">발송 결과(전체)</option>
          <option value="S">성공</option>
          <option value="F">실패</option>
        </select>
        <button class="btn btn-primary" @click="onSearch">조회</button>
      </div>
      <div class="tb-right">
        <button class="btn btn-gray" @click="receive">발송대상자 수신</button>
        <button class="btn btn-gray" @click="send">발송</button>
      </div>
    </div>

    <!-- 표 -->
    <table class="grid">
      <thead>
        <tr>
          <th><input type="checkbox" :checked="allChecked" @change="toggleAll($event)" /></th>
          <th>발송 날짜</th>
          <th>센터명</th>
          <th>이름</th>
          <th>아이디</th>
          <th>전화번호</th>
          <th>메시지 종류</th>
          <th>구매일</th>
          <th>만료일</th>
          <th>판정</th>
          <th>누적 수당</th>
          <th>한도</th>
          <th>판정</th>
          <th>발송 결과</th>
          <th>발송 내용</th>
          <th>실패 내용</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="r in rows" :key="r.id">
          <td><input type="checkbox" v-model="sel[r.customerId]" /></td>
          <td>{{ r.createDt }}</td>
          <td>{{ r.centerName }}</td>
          <td>{{ r.name }}</td>
          <td>{{ r.loginId }}</td>
          <td>{{ r.phone }}</td>
          <td>{{ msgLabel(r.msgType) }}</td>
          <td :class="{ 'c-red': isExpireRed(r) }">{{ r.purchaseDt || '-' }}</td>
          <td :class="{ 'c-red': isExpireRed(r) }">{{ r.expireDt || '-' }}</td>
          <td :class="{ 'c-red': isExpireRed(r) }">{{ jeongExpire(r) }}</td>
          <td :class="{ 'c-red': isLimitRed(r) }">{{ fmt(r.cumSudang) }}</td>
          <td :class="{ 'c-red': isLimitRed(r) }">{{ fmt(r.cumLimit) }}</td>
          <td :class="{ 'c-red': isLimitRed(r) }">{{ jeongLimit(r) }}</td>
          <td>
            <span v-if="resultLabel(r.sendResult) === '성공'" class="c-green">성공</span>
            <span v-else-if="resultLabel(r.sendResult) === '실패'" class="c-red">실패</span>
            <span v-else>-</span>
          </td>
          <td><button class="btn btn-xs" @click="openView('발송 내용', r.sendContent)">보기</button></td>
          <td><button class="btn btn-xs" @click="openView('실패 내용', r.failReason)">보기</button></td>
        </tr>
        <tr v-if="rows.length === 0">
          <td colspan="16" class="empty">조회된 대상자가 없습니다.</td>
        </tr>
      </tbody>
    </table>

    <Paging :page="paging.page" :size="paging.size" :total-count="paging.totalCount"
            :total-pages="paging.totalPages" @change-page="onPage" @change-size="onSize" />

    <!-- 보기 팝업 -->
    <div v-if="viewPopup.show" class="modal-mask" @click.self="viewPopup.show=false">
      <div class="modal-box">
        <h4>{{ viewPopup.title }}</h4>
        <textarea class="view-area" readonly :value="viewPopup.content"></textarea>
        <div class="modal-foot"><button class="btn" @click="viewPopup.show=false">닫기</button></div>
      </div>
    </div>

    <!-- 센터/회원 검색 : 기존 화면과 동일한 공용 팝업 컴포넌트 사용 -->
    <SettlementCenterSearchDialog v-if="centerPopup" @select="pickCenter" @close="centerPopup=false" />
    <SettlementMemberSearchDialog v-if="memberPopup" @select="pickMember" @close="memberPopup=false" />
  </div>
</template>

<script>
import api from '../api';
import Paging from '../components/Paging.vue';
import SettlementCenterSearchDialog from '../components/SettlementCenterSearchDialog.vue';
import SettlementMemberSearchDialog from '../components/SettlementMemberSearchDialog.vue';

export default {
  name: 'SmsTempSendView',
  components: { Paging, SettlementCenterSearchDialog, SettlementMemberSearchDialog },
  data() {
    return {
      filters: { centerName: '', name: '', phone: '', msgType: '', sendResult: '' },
      rows: [],
      sel: {},
      paging: { page: 1, size: 10, totalCount: 0, totalPages: 0 },
      viewPopup: { show: false, title: '', content: '' },
      centerPopup: false,
      memberPopup: false
    };
  },
  computed: {
    allChecked() {
      return this.rows.length > 0 && this.rows.every(r => this.sel[r.customerId]);
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      const params = {
        centerName: this.filters.centerName || undefined,
        name: this.filters.name || undefined,
        phone: this.filters.phone || undefined,
        msgType: this.filters.msgType || undefined,
        sendResult: this.filters.sendResult || undefined,
        page: this.paging.page,
        size: this.paging.size
      };
      try {
        const res = await api.smsTempList(params);
        const d = res.data || {};
        this.rows = d.list || [];
        this.paging.totalCount = d.totalCount || 0;
        this.paging.totalPages = d.totalPages || 0;
        this.sel = {};
      } catch (e) {
        alert(e.message || '조회 실패');
      }
    },
    onSearch() { this.paging.page = 1; this.load(); },
    onPage(p) { this.paging.page = p; this.load(); },
    onSize(s) { this.paging.size = s; this.paging.page = 1; this.load(); },
    toggleAll(e) {
      const v = e.target.checked;
      const next = {};
      this.rows.forEach(r => { next[r.customerId] = v; });
      this.sel = next;
    },
    async receive() {
      try {
        await api.smsTargetPurge();
        await api.smsTargetExtract();
        this.paging.page = 1;
        await this.load();
        alert('발송대상자 수신이 완료되었습니다.');
      } catch (e) {
        alert(e.message || '발송대상자 수신 실패');
      }
    },
    async send() {
      const items = this.rows
        .filter(r => this.sel[r.customerId])
        .map(r => ({ customerId: r.customerId, phone: r.phone }));
      if (items.length === 0) { alert('발송할 대상을 선택하세요.'); return; }
      const phones = items.map(i => i.phone || '(번호없음)').join(', ');
      if (!confirm(phones + ' 로 문자 발송하시겠습니까?')) return;
      try {
        const res = await api.smsSendTemp(items);
        alert(res.message || '발송 완료');
        await this.load();
      } catch (e) {
        alert(e.message || '발송 실패');
      }
    },
    // N = 30 - (생성일 - 구매일) + 1
    expireN(r) {
      if (!r.createDt || !r.purchaseDt) return null;
      return 30 - this.dayDiff(r.createDt, r.purchaseDt) + 1;
    },
    isExpireRed(r) {
      const n = this.expireN(r);
      return n !== null && n <= 3;
    },
    jeongExpire(r) {
      const n = this.expireN(r);
      return (n !== null && n <= 3) ? ('30일 기한 만료 ' + n + '일 전') : '-';
    },
    // 발송종류 001 + 발송종류 상세 0002~0004 → 적색 + 한도 판정
    isLimitRed(r) {
      return r.sendType === '001' && ['0002', '0003', '0004'].indexOf(r.sendTypeDtl) >= 0;
    },
    jeongLimit(r) {
      if (r.sendType !== '001') return '-';
      if (r.sendTypeDtl === '0002') return '300% 한도초과 1일 전';
      if (r.sendTypeDtl === '0003') return '300% 한도초과 2일 전';
      if (r.sendTypeDtl === '0004') return '300% 한도초과 3일 전';
      return '-';
    },
    resultLabel(v) {
      if (v === 'S' || v === 'Y') return '성공';
      if (v === 'F') return '실패';
      return '-';
    },
    msgLabel(v) {
      // 29003: L 이면 LMS, 그 외(빈값 등) SMS
      return v === 'L' ? 'LMS' : 'SMS';
    },
    openView(title, content) {
      this.viewPopup = { show: true, title, content: content || '' };
    },
    dayDiff(a, b) {
      const da = new Date(a + 'T00:00:00');
      const db = new Date(b + 'T00:00:00');
      return Math.round((da - db) / 86400000);
    },
    fmt(v) {
      if (v === null || v === undefined || v === '') return '-';
      const n = Number(v);
      return isNaN(n) ? v : n.toLocaleString();
    },
    // 공용 팝업에서 선택 시
    pickCenter(r) { this.filters.centerName = r.centerName; this.centerPopup = false; },
    pickMember(r) { this.filters.name = r.name; this.memberPopup = false; }
  }
};
</script>

<style scoped>
.sms-temp { background: #fff; padding: 18px; border-radius: 8px; }
h3 { margin: 0 0 14px; font-size: 18px; }
.toolbar { display: flex; justify-content: space-between; align-items: center; gap: 10px; flex-wrap: wrap; margin-bottom: 12px; }
.tb-left { display: flex; gap: 6px; align-items: center; flex-wrap: wrap; }
.tb-right { display: flex; gap: 6px; }
.ed { padding: 6px 8px; border: 1px solid #d0d5dd; border-radius: 5px; font-size: 13px; }
.ed-sm { width: 110px; }
.btn { padding: 6px 12px; border: 1px solid #c3cad6; background: #f4f6fa; border-radius: 5px; cursor: pointer; font-size: 13px; }
.btn:hover { background: #e9edf4; }
.btn-primary { background: #2f6fed; color: #fff; border-color: #2f6fed; }
.btn-primary:hover { background: #255fd0; }
.btn-gray { background: #8a93a3; color: #fff; border-color: #8a93a3; }
.btn-gray:hover { background: #79828f; }
.btn-xs { padding: 3px 8px; font-size: 12px; }
.grid { width: 100%; border-collapse: collapse; font-size: 13px; }
.grid th, .grid td { border: 1px solid #e3e7ef; padding: 7px 8px; text-align: center; white-space: nowrap; }
.grid th { background: #f3f5f9; font-weight: 600; }
.empty { color: #888; padding: 18px 0; }
.c-red { color: #d64545; }
.c-green { color: #1b8a3a; }
.modal-mask { position: fixed; inset: 0; background: rgba(20,28,48,0.35); display: flex; align-items: center; justify-content: center; z-index: 9000; }
.modal-box { background: #fff; border-radius: 10px; padding: 18px 20px; min-width: 360px; max-width: 90vw; max-height: 85vh; overflow: auto; box-shadow: 0 8px 30px rgba(0,0,0,0.25); }
.modal-box h4 { margin: 0 0 12px; }
.view-area { width: 100%; min-width: 320px; height: 140px; border: 1px solid #d0d5dd; border-radius: 6px; padding: 8px; font-size: 13px; resize: none; }
.modal-foot { text-align: right; margin-top: 12px; }
</style>
